import { LOAD_MINE_NEWS } from '@/store/protocols'
export default {
    name: 'mine/news',
    path: 'news',
    component: () => import('./Root.vue'),
    meta: {
        asyncData: LOAD_MINE_NEWS.join('/')
    }
}